import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { AnalysisStatus } from "../../model/Analysis";

type PendingStatus = Exclude<AnalysisStatus, "done" | "failed" | "waiting_for_match">;

type PreparationStep = {
  status: PendingStatus;
  label: MessageDescriptor;
  // Сколько шаг обычно занимает, секунды: «обычно до 0:15» у текущего шага.
  typicalS: number;
};

// Шаги подготовки разбора в порядке конвейера. `waiting_for_match` — тот же шаг,
// что `fetching_match`: матч ждём на шаге загрузки.
export const PREPARATION_STEPS: readonly PreparationStep[] = [
  {
    status: "queued",
    label: msg({ id: "analysis.step.queued", message: "In the queue" }),
    typicalS: 5,
  },
  {
    status: "fetching_match",
    label: msg({ id: "analysis.step.fetching_match", message: "Loading the match" }),
    typicalS: 15,
  },
  {
    status: "fetching_baselines",
    label: msg({
      id: "analysis.step.fetching_baselines",
      message: "Loading strong players on your hero",
    }),
    typicalS: 20,
  },
  {
    status: "analyzing",
    label: msg({ id: "analysis.step.analyzing", message: "Looking for mistakes" }),
    typicalS: 10,
  },
];
